import { render, staticRenderFns } from "./Synthesis.vue?vue&type=template&id=5faae97e&scoped=true&"
import script from "./Synthesis.vue?vue&type=script&lang=js&"
export * from "./Synthesis.vue?vue&type=script&lang=js&"
import style0 from "./Synthesis.vue?vue&type=style&index=0&id=5faae97e&prod&lang=scss&scoped=true&"
import style1 from "./Synthesis.vue?vue&type=style&index=1&id=5faae97e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faae97e",
  null
  
)

export default component.exports